import { parseISO } from 'date-fns'

import { usePeriod } from '@/services/period/usePeriod'
import { formatRange, PERIOD_LABELS, PERIODS, toInputDate } from '@/shared/lib/period'
import { SegmentedControl } from '@/shared/ui/SegmentedControl'

import s from './Topbar.module.css'

const OPTIONS = PERIODS.map((value) => ({ value, label: PERIOD_LABELS[value] }))

export function PeriodControl() {
  const { period, setPeriod, range, customRange, setCustomRange } = usePeriod()

  return (
    <div className={s.period}>
      <SegmentedControl options={OPTIONS} value={period} onChange={setPeriod} aria-label="Период" />
      <span className={s.range}>
        {period === 'custom' ? (
          <>
            <input
              type="date"
              aria-label="Начало периода"
              value={toInputDate(customRange.from)}
              max={toInputDate(customRange.to)}
              onChange={(e) =>
                e.target.value && setCustomRange({ ...customRange, from: parseISO(e.target.value) })
              }
            />
            –
            <input
              type="date"
              aria-label="Конец периода"
              value={toInputDate(customRange.to)}
              min={toInputDate(customRange.from)}
              onChange={(e) =>
                e.target.value && setCustomRange({ ...customRange, to: parseISO(e.target.value) })
              }
            />
          </>
        ) : (
          formatRange(range)
        )}
      </span>
    </div>
  )
}
